module.exports = __webpack_public_path__ + "img/bg_home.926795af.png";